import React from 'react';
import { Box, Button, InfoLabel } from '../../../../common/components';
import { hasPermission } from '../../../auth/redux/authActions';
import { Row, Col } from 'react-bootstrap';

const UserRoles = ({ resource, organisationRoles }) => {
  const resourceAttributes = resource.data.attributes;
  return (
    <Box>
      <h2 className="resource-name">{resourceAttributes.full_name}</h2>

      {organisationRoles &&
        Array.isArray(organisationRoles) &&
        organisationRoles.map((organisationRole, i) => {
          const roles = organisationRole?.roles?.data
            ?.map((role) => role?.attributes.name)
            .join(', ');
          return (
            <div>
              <Row key={i}>
                <Col sm={12}>
                  <h3>{organisationRole.organisation.data.attributes.name}</h3>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <InfoLabel label="Roles" value={roles} labelSize={1} />
                </Col>
              </Row>

              {hasPermission('user.edit') && (
                <Row>
                  <Col sm={12}>
                    <Button
                      link={true}
                      to={
                        '/admin/users/' +
                        resource.data.id +
                        '/organisations/' +
                        organisationRole.organisation.data.id +
                        '/edit'
                      }
                      bsStyle="primary"
                      className="pull-right"
                      rightIcon="pencil-square-o"
                    >
                      Edit Roles
                    </Button>
                  </Col>
                </Row>
              )}
            </div>
          );
        })}
    </Box>
  );
};

export default UserRoles;
